<template>
  <div>
    <div style="color: #194cc3; cursor: pointer" @click="isModalOpen = true">
      {{ clickCountRate }}%
    </div>
    <div
      class="review-picture-wrap"
      v-if="isModalOpen"
      @click.self="isModalOpen = false"
    >
      <div class="review-picture-modal text-left">
        <!-- head -->
        <h3 class="form-item py-5">Click Count Report</h3>
        <!-- body -->
        <div class="pa-5">
          <!-- title -->
          <h4 class="mb-5">{{ subject }}</h4>
          <section>
            <div class="form-item py-5 d-flex justify-space-between">
              <h5>Section</h5>
              <h5>Click Count</h5>
            </div>
            <div
              class="form-item py-5 d-flex justify-space-between"
              v-for="item in sections"
              :key="`section-${item.section}`"
            >
              <div>{{ item.section }}</div>
              <div>{{ item.clickCount }}</div>
            </div>
          </section>
        </div>
        <!-- foot -->
        <div class="pa-5 d-flex">
          <button class="btn ml-auto" @click="closeHandler">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isModalOpen: false,
    clickCountRate: 1.33,
    subject: 'Shop ADATA special: subject wowo XENIA+PRECOG Combo!',
    sections: [
      { section: 'Header', clickCount: 185 },
      { section: 'Banner', clickCount: 6 },
      { section: 'SNS Share', clickCount: 23 },
      { section: 'Section 1', clickCount: 23 },
      { section: 'Section 2', clickCount: 102 },
      { section: 'Section 3', clickCount: 51 },
      { section: 'Section 4', clickCount: 23 },
      { section: 'Section 5', clickCount: 102 },
      { section: 'Section 6', clickCount: 51 },
    ],
  }),
  methods: {
    closeHandler() {
      this.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.review-picture {
  &-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(160, 160, 160, 0.5);
    z-index: 5;
  }
  &-modal {
    max-height: 700px;
    overflow: auto;
    width: 720px;
    margin: 0 auto;
    margin-top: 40px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
